export const navbarHeight = 64
export const navbarHeightVD = 42

export default { navbarHeight, navbarHeightVD }
